import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Navbar from '../components/Navbar';
export default function TeamProfile({ title }) {
  const { pk } = useParams();
  const [team, setTeam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/teams/${pk}/profile/`)
      .then(res => res.ok ? res.json() : Promise.reject('خطا در دریافت'))
      .then(data => setTeam(data))
      .catch(err => setError(err))
      .finally(() => setLoading(false));
  }, [pk]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-900">
        <svg className="animate-spin h-12 w-12 text-cyan-500" viewBox="0 0 24 24" fill="none" stroke="currentColor">
          <circle cx="12" cy="12" r="10" strokeWidth="4" className="opacity-25" />
          <path d="M4 12a8 8 0 018-8v8z" className="opacity-75" />
        </svg>
      </div>
    );
  }

  if (error) {
    return <p className="text-red-500 p-4 bg-gray-900">{error}</p>;
  }

  if (!team) {
    return null;
  }

  return (
    <div dir="rtl" className="min-h-screen bg-gray-900 text-gray-100 p-6">
        <Navbar />
      {/* Title */}
      <h1 className="mt-24 text-3xl font-bold mb-6 text-right">{title}</h1>

      {/* Header */}
      <div className="flex  items-center mb-8 space-x-6 space-x-reverse">
        {team.teampic ? (
          <img
            src={`${process.env.REACT_APP_BACKEND_URL}${team.teampic}`}
            alt="team"
            className="w-32 h-32 rounded-full object-cover border-4 border-slate-600"
          />
        ) : (
          <div className="w-32 h-32 rounded-full border-4 border-slate-600 bg-gray-700 flex items-center justify-center text-gray-400">
            بدون تصویر
          </div>
        )}
        <div className="text-right">
          <h2 className="text-3xl font-bold">{team.teamname}</h2>
          <p className="text-lg text-gray-400">{team.teamfullname}</p>
          <p className="mt-1 text-gray-300">لیدر تیم: {team.firstname} {team.lastname}</p>
          <p className="mt-2 p-2 bg-gray-800 rounded text-right">
            {team.teamdesc || 'بدون توضیح.'}
          </p>
          <div className="mt-4">
            <span className="px-3 py-1 bg-gray-800 text-sm rounded-full border border-gray-700">
              لیگ: {team.league_name}
            </span>
          </div>
        </div>
      </div>

      {/* Members Table */}
      <div className="mb-8">
        <h3 className="text-2xl font-semibold mb-4 text-right">اعضای تیم</h3>
        <div className="overflow-x-auto bg-gray-800 rounded-lg shadow">
          <table className="min-w-full divide-y divide-gray-700">
            <thead className="bg-gray-700">
              <tr>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-200">نام</th>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-200">نام خانوادگی</th>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-200">نقش</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
              {team.members && team.members.length > 0 ? (
                team.members.map(m => (
                  <tr key={m.id} className="hover:bg-gray-700">
                    <td className="px-4 py-2 text-sm text-right">{m.firstname}</td>
                    <td className="px-4 py-2 text-sm text-right">{m.lastname}</td>
                    <td className="px-4 py-2 text-sm text-right">{m.expert}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="px-4 py-6 text-center text-gray-500">عضوی ثبت نشده.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* Scores Table */}
      <div>
        {team.show_leaderboard ? (
            <>
        <h3 className="text-2xl font-semibold mb-4 text-right">امتیازات</h3>
        <div className="overflow-x-auto bg-gray-800 rounded-lg shadow">
          <table className="min-w-full divide-y divide-gray-700">
            <thead className="bg-gray-700">
              <tr>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-200">سوال</th>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-200">امتیاز</th>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-200">داور</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-700">
                
              {team.scores && team.scores.length > 0 ? (
                team.scores.map(s => (
                  <tr key={s.id} className="hover:bg-gray-700">
                    <td className="px-4 py-2 text-sm text-right">{s.question_text}</td>
                    <td className="px-4 py-2 text-sm text-right">{s.score}</td>
                    <td className="px-4 py-2 text-sm text-right">{s.judge_firstname} {s.judge_lastname}</td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="3" className="px-4 py-6 text-center text-gray-500">هنوز امتیازی ثبت نشده.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
         </>
        ) : (
  <p className="text-center text-gray-400 mt-6">نتیجه نهایی یافت نشد.</p>
)}
      </div>
    </div>
  );
}